import { useEffect, useState } from 'react';

import AmountInput from 'components/ui/Input/AmountInput';

import styles from '../Withdraw.module.css';
import PhoneInput from 'components/ui/Input/Phone';

import { useZustandFormsStore } from 'stores/money/forms/store';
import { useZustandPaymentsStore } from 'stores/money/payments/store';
import { setPaymentsCurrentStepAction } from 'stores/money/payments/selectors';
import { getUserCurrencyIdSelector } from 'stores/user/personal/selectors';
import { useZustandUserStore } from 'stores/user/personal/store';
import { setFormsInfoAction } from 'stores/money/forms/selectors';
import { Steps } from 'stores/money/payments/types';

import { ERequestIds } from 'react-memory-optimization/dist/lib/binary/types';

import { PaymentChannelType } from 'react-memory-optimization/dist/lib/store/user/types';
import { DEFAULT_INPUT_VALUE } from 'components/ui/Input/Base/constant';
import { DefaultInputType } from 'react-gldn-kit/dist/lib/components/ui/Inputs/BaseInput/types';
import Input from 'components/ui/Input/Base';

type Props = {
  min: number;
  max: number;
  phoneData?: {
    countryCodeDefault: string;
    defaultValue: string;
  };
  channelId: PaymentChannelType.EasypaisaFast | PaymentChannelType.JazzCash;
};

const APayEasyandJazz = (props: Props) => {
  const { min, max, channelId } = props;

  const setFormInfo = useZustandFormsStore(setFormsInfoAction);

  const [phone, setPhone] = useState('');

  const setStep = useZustandPaymentsStore(setPaymentsCurrentStepAction);

  const currencyId = useZustandUserStore(getUserCurrencyIdSelector);

  const [amount, setAmount] = useState('');

  const [accountName, setAccountName] =
    useState<DefaultInputType>(DEFAULT_INPUT_VALUE);

  const handleChangeAccountName = (v: string) => {
    const isValid = v.length <= 50;

    setAccountName({
      value: v,
      errorText: isValid ? '' : 'errors.invalidData',
    });
  };

  useEffect(() => {
    if (
      amount &&
      currencyId &&
      accountName.value &&
      phone.length &&
      phone.length === 13
    ) {
      setFormInfo({
        isDeposit: false,
        form: {
          amount,
          phone: `0${phone.slice(3, phone.length)}`,
          emptyOne: accountName.value,
          emptyTwo: accountName.value,
          channelId,
          currencyId,
          requestId: ERequestIds.WithdrawRequest,
        },
      });

      setStep(Steps.FilledForm);
    } else {
      setStep(Steps.Amount);
      setFormInfo(null);
    }
  }, [amount, currencyId, accountName, channelId, phone]);

  return (
    <div>
      <AmountInput
        isWithdraw
        placeholder="walletPopUp.forms.amount"
        inputStyleType="border-colorful"
        inputLabelType="labelUp"
        size="full"
        onChange={setAmount}
        isPresets={false}
        min={min}
        max={max}
        wrapperClasses={styles.marginInputBottom}
      />

      <Input
        placeholder="walletPopUp.forms.accountHolderName"
        inputStyleType="border-colorful"
        inputLabelType="labelUp"
        size="full"
        classes={styles.marginInputBottom}
        errorText={accountName.errorText}
        onChange={handleChangeAccountName}
      />

      <PhoneInput
        countryCodeDefault="PK"
        withConfirm={false}
        inputStyleType="border-colorful"
        inputLabelType="labelUp"
        size="full"
        sendKey="09x"
        defaultValue="+92"
        onChange={setPhone}
        baseValue="+92"
        errorText={phone.length && phone.length !== 13 ? 'errors.phone' : ''}
        classesWrapper={styles.marginInputBottom}
        placeholder="walletPopUp.forms.phone"
      />
    </div>
  );
};

export default APayEasyandJazz;
